export const dramas = [
  {
    id: "chongsheng-jiaqianjin",
    title: "重生之假千金上门",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20an%20elegant%20young%20woman%20in%20a%20cream%20silk%20dress%20standing%20in%20a%20warm%20luxurious%20mansion%20hallway%20with%20golden%20afternoon%20light%2C%20dramatic%20moody%20shadows%2C%20crimson%20and%20gold%20color%20scheme%2C%20high%20fashion%20editorial%20photography%2C%20clean%20composition&width=600&height=800&seq=duanju-cover-01&orientation=portrait",
    tags: ["都市", "逆袭", "复仇"],
    region: "中国大陆",
    episodes: 82,
    year: 2025,
    rating: 8.6,
    ratingCount: 12480,
    heat: 98200,
    status: "已完结",
    director: "陈望舒",
    screenwriter: "林知微",
    producer: "星野短剧工作室",
    synopsis:
      "被抱错十八年的真千金回到豪门，却发现自己不过是被精心安排的替代品。她没有哭闹，而是带着上一世的记忆冷静布局，一步步撕开家族的体面外衣。谁才是被真正抛弃的人，谁又在暗中递出刀子，答案远比血缘更锋利。",
    cast: [
      { name: "沈砚青", role: "苏未晞", avatar: "https://readdy.ai/api/search-image?query=elegant%20young%20actress%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20calm%20confident%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-01a&orientation=squarish" },
      { name: "顾南宸", role: "陆时衍", avatar: "https://readdy.ai/api/search-image?query=handsome%20young%20actor%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20sharp%20tailored%20dark%20suit%2C%20editorial%20fashion%20photography&width=400&height=400&seq=duanju-cast-01b&orientation=squarish" },
      { name: "温以宁", role: "苏家二夫人", avatar: "https://readdy.ai/api/search-image?query=mature%20elegant%20chinese%20woman%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20lighting%2C%20poised%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-01c&orientation=squarish" },
      { name: "秦子越", role: "苏家长子", avatar: "https://readdy.ai/api/search-image?query=young%20serious%20male%20actor%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20neutral%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-01d&orientation=squarish" },
    ],
    behindScenes: [
      "真千金回门那场戏拍了整整十七遍，导演要求演员在推门瞬间眼神先从期待变成判断，再落到平静。",
      "剧中苏家老宅是实景搭建，木楼梯全部由老工匠手工上漆，为了拍出旧木头的哑光质感。",
      "女主同款连衣裙在剧集上线后三天内售罄，服装组透露一共准备了十一套同色不同剪裁的备选。",
    ],
  },
  {
    id: "guilai-shaonianlang",
    title: "归来仍是少年郎",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20young%20man%20in%20a%20simple%20beige%20shirt%20standing%20on%20a%20small%20town%20street%20at%20sunset%2C%20warm%20orange%20light%2C%20nostalgic%20cinematic%20mood%2C%20soft%20film%20grain%2C%20clean%20composition&width=600&height=800&seq=duanju-cover-02&orientation=portrait",
    tags: ["家庭", "温情", "现实"],
    region: "中国大陆",
    episodes: 64,
    year: 2025,
    rating: 9.1,
    ratingCount: 8760,
    heat: 76400,
    status: "已完结",
    director: "赵屿",
    screenwriter: "柳青禾",
    producer: "长巷影业",
    synopsis:
      "在外打拼十年的江野回到小镇，才发现父母把最难的日子都藏在了电话里的那句「都挺好」中。他本想处理完老屋就离开，却被一桩关于父亲旧友的往事绊住了脚步。这是一个关于和解、关于迟到的理解的故事。",
    cast: [
      { name: "江野", role: "江野", avatar: "https://readdy.ai/api/search-image?query=young%20man%20portrait%20studio%20headshot%20with%20warm%20beige%20backdrop%2C%20soft%20natural%20light%2C%20gentle%20honest%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-02a&orientation=squarish" },
      { name: "周惠兰", role: "江母", avatar: "https://readdy.ai/api/search-image?query=warm%20middle%20aged%20chinese%20mother%20portrait%20studio%20headshot%20with%20beige%20backdrop%2C%20soft%20lighting%2C%20kind%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-02b&orientation=squarish" },
      { name: "沈砚青", role: "林晚", avatar: "https://readdy.ai/api/search-image?query=elegant%20young%20actress%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20calm%20confident%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-02c&orientation=squarish" },
    ],
    behindScenes: [
      "小镇主场景选在南方一座真实的旧街区，剧组提前两个月与居民沟通，保留了原有的店铺招牌。",
      "结尾父亲遗物的特写镜头用的是一台真实的老式收音机，演员坚持不排练，第一条即过。",
      "主题曲由剧中男主演亲自哼唱的小样定稿，制作人形容那种不完美的沙哑感正是小镇的味道。",
    ],
  },
  {
    id: "chang-gongzhu",
    title: "长公主在上",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20regal%20ancient%20chinese%20princess%20in%20deep%20crimson%20embroidered%20hanfu%20holding%20a%20jade%20fan%2C%20palace%20corridor%20background%2C%20warm%20candlelight%2C%20rich%20gold%20details%2C%20dramatic%20cinematic%20lighting%2C%20elegant%20composition&width=600&height=800&seq=duanju-cover-03&orientation=portrait",
    tags: ["古装", "权谋", "爱情"],
    region: "中国大陆",
    episodes: 96,
    year: 2024,
    rating: 8.9,
    ratingCount: 20340,
    heat: 132500,
    status: "已完结",
    director: "裴沉舟",
    screenwriter: "苏禾",
    producer: "云章古装剧场",
    synopsis:
      "长公主萧临月手握半朝兵符，却被幼弟视为眼中钉。她一边在朝堂上与各方角力，一边扶持寒门出身的谋士谢知白。两人从互相试探到彼此托付，在权谋的缝隙里长出一点不合时宜的真心。",
    cast: [
      { name: "陆昭宁", role: "萧临月", avatar: "https://readdy.ai/api/search-image?query=elegant%20ancient%20chinese%20costume%20actress%20portrait%20studio%20headshot%20with%20warm%20crimson%20backdrop%2C%20soft%20candlelight%2C%20regal%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-03a&orientation=squarish" },
      { name: "谢云阶", role: "谢知白", avatar: "https://readdy.ai/api/search-image?query=ancient%20chinese%20scholar%20scholar%20costume%20male%20portrait%20studio%20headshot%20with%20warm%20amber%20backdrop%2C%20soft%20lighting%2C%20thoughtful%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-03b&orientation=squarish" },
      { name: "裴沉舟", role: "少帝萧呈", avatar: "https://readdy.ai/api/search-image?query=young%20ancient%20chinese%20emperor%20costume%20male%20portrait%20studio%20headshot%20with%20dark%20crimson%20backdrop%2C%20dramatic%20lighting%2C%20intense%20expression%2C%20cinematic%20photography&width=400&height=400&seq=duanju-cast-03c&orientation=squarish" },
      { name: "温以宁", role: "太后", avatar: "https://readdy.ai/api/search-image?query=mature%20elegant%20ancient%20chinese%20empress%20costume%20portrait%20studio%20headshot%20with%20warm%20gold%20backdrop%2C%20soft%20lighting%2C%20poised%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-03d&orientation=squarish" },
    ],
    behindScenes: [
      "朝堂大戏动用了一百二十七位群演，服装组为每位演员单独做了纹样分区，避免镜头扫过时出现重复。",
      "长公主的兵符道具做了铜、木、树脂三个版本，分别用于特写、把玩和远景挥动，重量差异让演员的手势更自然。",
      "主创团队为台词专门请了古典文学顾问，剧中海报和奏折文字均为手写后扫描，没有使用电脑字库。",
    ],
  },
  {
    id: "shanhun-zongcai",
    title: "闪婚后，总裁每天都在宠我",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20stylish%20young%20couple%20in%20modern%20city%20setting%2C%20warm%20sunset%20light%20through%20glass%20office%20windows%2C%20soft%20romantic%20mood%2C%20crimson%20accent%20details%2C%20clean%20editorial%20composition&width=600&height=800&seq=duanju-cover-04&orientation=portrait",
    tags: ["甜宠", "都市", "契约婚姻"],
    region: "中国大陆",
    episodes: 78,
    year: 2025,
    rating: 8.2,
    ratingCount: 15620,
    heat: 88900,
    status: "已完结",
    director: "许清河",
    screenwriter: "顾笙",
    producer: "星野短剧工作室",
    synopsis:
      "为了替家里还债，苏软签下一纸婚约，对方是传闻中冷面无情的企业掌权人。她本以为只是各取所需，没想到那些被她忽略的细节，早就写好了另一种答案。婚后第一百天，她收到了一份没有署名的礼物。",
    cast: [
      { name: "苏软", role: "苏软", avatar: "https://readdy.ai/api/search-image?query=sweet%20young%20actress%20portrait%20studio%20headshot%20with%20warm%20peach%20backdrop%2C%20soft%20lighting%2C%20playful%20smile%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-04a&orientation=squarish" },
      { name: "顾南宸", role: "傅寒川", avatar: "https://readdy.ai/api/search-image?query=handsome%20young%20actor%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20sharp%20tailored%20dark%20suit%2C%20editorial%20fashion%20photography&width=400&height=400&seq=duanju-cast-04b&orientation=squarish" },
      { name: "林知夏", role: "苏软的闺蜜", avatar: "https://readdy.ai/api/search-image?query=lively%20young%20woman%20portrait%20studio%20headshot%20with%20warm%20terracotta%20backdrop%2C%20bright%20soft%20light%2C%20cheerful%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-04c&orientation=squarish" },
    ],
    behindScenes: [
      "男女主第一次同框的电梯戏只有两分半钟，却拍了一整个通宵，只为了找准那种「想靠近又后退」的距离感。",
      "道具组为总裁办公室准备了三百多本书，全部按人物性格挑过，书脊颜色统一为暖调，避免画面显乱。",
      "剧组透露，女主那句出圈台词是演员现场改的，原剧本写得太工整，导演让她换成更口语的说法。",
    ],
  },
  {
    id: "shifu-jianxian",
    title: "我的师父是剑仙",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20young%20sword%20immortal%20in%20white%20flowing%20robes%20standing%20on%20a%20misty%20mountain%20peak%2C%20golden%20sunrise%20light%2C%20epic%20fantasy%20mood%2C%20warm%20amber%20tones%2C%20dramatic%20cinematic%20composition&width=600&height=800&seq=duanju-cover-05&orientation=portrait",
    tags: ["玄幻", "热血", "师徒"],
    region: "中国大陆",
    episodes: 88,
    year: 2024,
    rating: 8.4,
    ratingCount: 11290,
    heat: 91300,
    status: "已完结",
    director: "裴沉舟",
    screenwriter: "苏禾",
    producer: "云章古装剧场",
    synopsis:
      "少年陆行舟误入深山，拜在一位自称「懒得管天下事」的剑仙门下。师父教他的第一课不是剑法，而是如何挨打。当山门外的纷争烧到山下小镇，他才懂那句「剑是最后才出的手」到底有多重。",
    cast: [
      { name: "裴沉舟", role: "云无咎", avatar: "https://readdy.ai/api/search-image?query=young%20ancient%20chinese%20sword%20immortal%20white%20robes%20portrait%20studio%20headshot%20with%20misty%20amber%20backdrop%2C%20soft%20lighting%2C%20calm%20expression%2C%20cinematic%20photography&width=400&height=400&seq=duanju-cast-05a&orientation=squarish" },
      { name: "江野", role: "陆行舟", avatar: "https://readdy.ai/api/search-image?query=young%20man%20portrait%20studio%20headshot%20with%20warm%20beige%20backdrop%2C%20soft%20natural%20light%2C%20gentle%20honest%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-05b&orientation=squarish" },
      { name: "秦子越", role: "反派楚璟", avatar: "https://readdy.ai/api/search-image?query=young%20serious%20male%20actor%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20neutral%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-05c&orientation=squarish" },
    ],
    behindScenes: [
      "剑仙的竹剑共有九把，每把的磨损程度对应剧情不同阶段，细节控观众在弹幕里逐帧找过。",
      "云雾山景大量使用实景加薄雾机拍摄，演员吊威亚时地上铺了三层缓冲垫，动作指导全程跟组。",
      "师父教剑的那段长镜头是一条过的，摄影机跟着两位演员走了将近四分钟。",
    ],
  },
  {
    id: "moban-ditie",
    title: "末班地铁的陌生人",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20lone%20figure%20standing%20in%20an%20empty%20modern%20subway%20carriage%20at%20night%2C%20warm%20amber%20station%20lights%20against%20dark%20tunnel%2C%20mysterious%20moody%20atmosphere%2C%20film%20noir%20composition&width=600&height=800&seq=duanju-cover-06&orientation=portrait",
    tags: ["悬疑", "都市", "烧脑"],
    region: "中国大陆",
    episodes: 56,
    year: 2025,
    rating: 8.8,
    ratingCount: 9430,
    heat: 82100,
    status: "已完结",
    director: "赵屿",
    screenwriter: "柳青禾",
    producer: "长巷影业",
    synopsis:
      "每天最后一班地铁上，总有一个捧着旧报纸的男人坐在同一节车厢。加班到深夜的记者程桐某天鼓起勇气搭话，却在第二天看到了一则关于他的失踪报道。她开始怀疑，自己记忆里的那一站，究竟有没有停过。",
    cast: [
      { name: "程桐", role: "程桐", avatar: "https://readdy.ai/api/search-image?query=thoughtful%20young%20woman%20portrait%20studio%20headshot%20with%20warm%20grey%20backdrop%2C%20soft%20lighting%2C%20quiet%20curious%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-06a&orientation=squarish" },
      { name: "谢云阶", role: "报纸男人", avatar: "https://readdy.ai/api/search-image?query=ancient%20chinese%20scholar%20scholar%20costume%20male%20portrait%20studio%20headshot%20with%20warm%20amber%20backdrop%2C%20soft%20lighting%2C%20thoughtful%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-06b&orientation=squarish" },
    ],
    behindScenes: [
      "为了拍出「空车厢」的压迫感，剧组包下一整条运营结束后的地铁支线，只有两个小时的拍摄窗口。",
      "剧本里那双列车员的皮鞋的鞋跟磨痕，是美术组用小刀一点点削出来的，镜头只给了三秒。",
      "结尾那个长镜头其实藏了七处线索，播出后观众整理的推理贴超过了两百页。",
    ],
  },
  {
    id: "caili-fengbo",
    title: "彩礼风波",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20chinese%20family%20gathering%20around%20a%20dining%20table%20in%20a%20small%20town%20home%2C%20warm%20evening%20lamp%20light%2C%20tension%20and%20warmth%20mixed%2C%20documentary%20realism%20style%2C%20earthy%20tones&width=600&height=800&seq=duanju-cover-07&orientation=portrait",
    tags: ["现实", "家庭伦理", "话题"],
    region: "中国大陆",
    episodes: 60,
    year: 2024,
    rating: 8.0,
    ratingCount: 7210,
    heat: 67300,
    status: "已完结",
    director: "许清河",
    screenwriter: "顾笙",
    producer: "长巷影业",
    synopsis:
      "两家人围坐在一张饭桌前，把一桩婚事谈成了拉锯战。女儿夹在中间，儿子站在父母身后，谁都没有错，可谁都在受伤。这部剧不讲大道理，只是把一顿饭吃到了天亮。",
    cast: [
      { name: "周惠兰", role: "女方母亲", avatar: "https://readdy.ai/api/search-image?query=warm%20middle%20aged%20chinese%20mother%20portrait%20studio%20headshot%20with%20beige%20backdrop%2C%20soft%20lighting%2C%20kind%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-07a&orientation=squarish" },
      { name: "林知夏", role: "女儿小满", avatar: "https://readdy.ai/api/search-image?query=lively%20young%20woman%20portrait%20studio%20headshot%20with%20warm%20terracotta%20backdrop%2C%20bright%20soft%20light%2C%20cheerful%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-07b&orientation=squarish" },
      { name: "江野", role: "男方阿凯", avatar: "https://readdy.ai/api/search-image?query=young%20man%20portrait%20studio%20headshot%20with%20warm%20beige%20backdrop%2C%20soft%20natural%20light%2C%20gentle%20honest%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-07c&orientation=squarish" },
    ],
    behindScenes: [
      "全剧百分之七十的戏份发生在一张饭桌前，摄影指导用了六台机位同时拍摄，保证演员不用为走位喊停。",
      "剧本初稿的结局是和解，主创反复讨论后改成了「先各自冷静」，导演说生活里没那么多当场圆满。",
      "桌上的菜都是真实现做的，剧组专门请了本地厨师，拍摄结束时全组吃了那顿饭。",
    ],
  },
  {
    id: "minguo-xiaochuniang",
    title: "民国小厨娘",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20young%20woman%20in%201930s%20chinese%20cheongsam%20in%20a%20warm%20vintage%20kitchen%2C%20steaming%20bamboo%20baskets%2C%20golden%20lantern%20light%2C%20nostalgic%20republic%20era%20style%2C%20warm%20sepia%20tones%2C%20elegant%20composition&width=600&height=800&seq=duanju-cover-08&orientation=portrait",
    tags: ["民国", "美食", "爱情"],
    region: "中国大陆",
    episodes: 72,
    year: 2024,
    rating: 8.5,
    ratingCount: 8890,
    heat: 71500,
    status: "已完结",
    director: "陈望舒",
    screenwriter: "林知微",
    producer: "云章古装剧场",
    synopsis:
      "战乱年代，小厨娘阿棠靠着家传的一本食谱在弄堂口支起摊子。她喂饱了流亡的学生、落魄的先生，也喂饱了一颗不敢靠近的心。一碟葱油拌面，有时候比长篇大论更能留住人。",
    cast: [
      { name: "陆昭宁", role: "沈棠", avatar: "https://readdy.ai/api/search-image?query=elegant%20ancient%20chinese%20costume%20actress%20portrait%20studio%20headshot%20with%20warm%20crimson%20backdrop%2C%20soft%20candlelight%2C%20regal%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-08a&orientation=squarish" },
      { name: "顾南宸", role: "陆先生", avatar: "https://readdy.ai/api/search-image?query=handsome%20young%20actor%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20sharp%20tailored%20dark%20suit%2C%20editorial%20fashion%20photography&width=400&height=400&seq=duanju-cast-08b&orientation=squarish" },
    ],
    behindScenes: [
      "剧中出现的四十六道菜全部由美食顾问现场制作，葱油拌面的关键一步只用一个镜头交代，却被弹幕反复截图。",
      "弄堂布景参考了老照片里的石库门结构，连晾衣竹竿的间距都按资料还原。",
      "女主切菜的镜头没有用替身，开拍前她跟老师傅练了半个多月的刀工。",
    ],
  },
  {
    id: "shenji-jianbaoshi",
    title: "神级鉴宝师",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20young%20appraiser%20in%20a%20dark%20suit%20examining%20an%20ancient%20porcelain%20vase%20under%20warm%20spotlight%2C%20antique%20shop%20background%2C%20rich%20amber%20and%20crimson%20tones%2C%20dramatic%20cinematic%20lighting&width=600&height=800&seq=duanju-cover-09&orientation=portrait",
    tags: ["都市", "异能", "爽感"],
    region: "中国大陆",
    episodes: 90,
    year: 2025,
    rating: 7.9,
    ratingCount: 10240,
    heat: 84700,
    status: "已完结",
    director: "许清河",
    screenwriter: "苏禾",
    producer: "星野短剧工作室",
    synopsis:
      "一次意外让秦砚开眼，从此能看见古物上残留的痕迹。他混迹于古玩市场，从一枚被当作赝品的铜钱开始，一步步走进这个行业最不愿被看见的那一层。眼力能换来财富，也能换来麻烦。",
    cast: [
      { name: "秦子越", role: "秦砚", avatar: "https://readdy.ai/api/search-image?query=young%20serious%20male%20actor%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20window%20light%2C%20neutral%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-09a&orientation=squarish" },
      { name: "温以宁", role: "古董行老板娘", avatar: "https://readdy.ai/api/search-image?query=mature%20elegant%20chinese%20woman%20portrait%20studio%20headshot%20with%20warm%20cream%20backdrop%2C%20soft%20lighting%2C%20poised%20expression%2C%20editorial%20beauty%20photography&width=400&height=400&seq=duanju-cast-09b&orientation=squarish" },
      { name: "林知夏", role: "实习生小圆", avatar: "https://readdy.ai/api/search-image?query=lively%20young%20woman%20portrait%20studio%20headshot%20with%20warm%20terracotta%20backdrop%2C%20bright%20soft%20light%2C%20cheerful%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-09c&orientation=squarish" },
    ],
    behindScenes: [
      "鉴宝用的放大镜、镊子和白手套都由真实的古玩从业者提供，演员提前进组学习了一个月的上手规矩。",
      "剧中那枚关键铜钱是道具师用真品拓模后做的，为了拍出包浆的层次，一共做了十二个版本。",
      "古玩市场的群戏用了长焦压缩空间的拍法，让画面里的摊位看起来比实际更密集。",
    ],
  },
  {
    id: "shanhai-miwenlu",
    title: "山海秘闻录",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20vertical%20poster%20of%20a%20lone%20traveler%20in%20dark%20ancient%20robes%20standing%20before%20a%20giant%20stone%20gate%20carved%20with%20mythical%20beasts%2C%20misty%20mountains%2C%20warm%20torch%20light%20against%20deep%20shadows%2C%20epic%20fantasy%20cinematic%20mood&width=600&height=800&seq=duanju-cover-10&orientation=portrait",
    tags: ["玄幻", "古装", "冒险"],
    region: "中国大陆",
    episodes: 100,
    year: 2024,
    rating: 8.7,
    ratingCount: 13870,
    heat: 108600,
    status: "已完结",
    director: "裴沉舟",
    screenwriter: "柳青禾",
    producer: "云章古装剧场",
    synopsis:
      "山海图志散落人间，凡人得之可窥异兽行踪。少年游方为寻找失踪的兄长踏上旅途，一路上遇见的怪事，都指向同一扇门。门后是什么，有人想封住，有人想推开。",
    cast: [
      { name: "江野", role: "游方", avatar: "https://readdy.ai/api/search-image?query=young%20man%20portrait%20studio%20headshot%20with%20warm%20beige%20backdrop%2C%20soft%20natural%20light%2C%20gentle%20honest%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-10a&orientation=squarish" },
      { name: "谢云阶", role: "谋士闻朝", avatar: "https://readdy.ai/api/search-image?query=ancient%20chinese%20scholar%20scholar%20costume%20male%20portrait%20studio%20headshot%20with%20warm%20amber%20backdrop%2C%20soft%20lighting%2C%20thoughtful%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-10b&orientation=squarish" },
      { name: "程桐", role: "巫女阿箬", avatar: "https://readdy.ai/api/search-image?query=thoughtful%20young%20woman%20portrait%20studio%20headshot%20with%20warm%20grey%20backdrop%2C%20soft%20lighting%2C%20quiet%20curious%20expression%2C%20editorial%20photography&width=400&height=400&seq=duanju-cast-10c&orientation=squarish" },
      { name: "裴沉舟", role: "神秘商人", avatar: "https://readdy.ai/api/search-image?query=young%20ancient%20chinese%20sword%20immortal%20white%20robes%20portrait%20studio%20headshot%20with%20misty%20amber%20backdrop%2C%20soft%20lighting%2C%20calm%20expression%2C%20cinematic%20photography&width=400&height=400&seq=duanju-cast-10d&orientation=squarish" },
    ],
    behindScenes: [
      "异兽设计参考了大量古籍插画，特效团队最初做了三十版草稿，最后选定了最不像怪兽、最像神像的那一版。",
      "石门的实景高六米，用泡沫雕刻后覆上石材纹理，特写时才切换为局部真实石雕。",
      "主题曲的编曲里加入了一种几乎失传的民间吹奏乐器，录音地点就在拍摄地的山谷里。",
    ],
  },
];

export const dramaCategories = [
  { key: "all", label: "全部" },
  { key: "都市", label: "都市" },
  { key: "古装", label: "古装" },
  { key: "玄幻", label: "玄幻" },
  { key: "悬疑", label: "悬疑" },
  { key: "家庭", label: "家庭" },
  { key: "甜宠", label: "甜宠" },
  { key: "民国", label: "民国" },
];